import { useEffect } from 'react';
import { SHOW_OVERLAY_WITH_TOOLBAR_AND_BANNERS_CLASS, SHOW_OVERLAY_WITH_NAV_CLASS, SHOW_OVERLAY_WITHOUT_BANNERS_CLASS } from '../constants';
import { useOverlayDisplayLogic } from './useOverlayDisplayLogic';
import { useOverlayState } from './useOverlayState';
export function useUpdateToolbarAndNavDisplayStyles() {
  const {
    isOverlayConfigStateInit,
    isTopLevelWindow
  } = useOverlayDisplayLogic();
  const [isOverlayOpen, shouldShowNav, shouldShowToolbar] = useOverlayState();
  useEffect(() => {
    if (isOverlayConfigStateInit && isTopLevelWindow) {
      const bodyEl = document.querySelector('body.sticky-global-toolbar');
      if (bodyEl) {
        if (!isOverlayOpen) {
          bodyEl.classList.remove(SHOW_OVERLAY_WITH_TOOLBAR_AND_BANNERS_CLASS, SHOW_OVERLAY_WITH_NAV_CLASS, SHOW_OVERLAY_WITHOUT_BANNERS_CLASS);
          return;
        }
        if (!shouldShowToolbar) {
          // Set the Z-index to make sure that banners don't show up over the overlay
          bodyEl.classList.add(SHOW_OVERLAY_WITHOUT_BANNERS_CLASS);
        } else if (shouldShowToolbar) {
          bodyEl.classList.add(SHOW_OVERLAY_WITH_TOOLBAR_AND_BANNERS_CLASS);
        }
        if (shouldShowNav) {
          bodyEl.classList.add(SHOW_OVERLAY_WITH_NAV_CLASS);
        }
      }
    }
  }, [shouldShowNav, shouldShowToolbar, isOverlayOpen, isOverlayConfigStateInit, isTopLevelWindow]);
}